export function schema_insee(prevColumnNames) {
	return {
		title: "Paramètres",
		type: "object",
		properties: {
			column_ville: {
				title: "Colonne ville",
				type: "string",
				options: {
					inputAttributes: {
						class: "form-control dropdown-colonne",
					},
				},
			},
			column_code_postal: {
				title: "Colonne code postal",
				type: "string",
				options: {
					inputAttributes: {
						class: "form-control dropdown-colonne",
					},
				},
			},
			column_insee: {
				title: "Colonne insee",
				type: "string",
				options: {
					inputAttributes: {
						class: "form-control dropdown-colonne",
					},
				},
			},
			column_code_departement: {
				title: "Colonne code département",
				type: "string",
				options: {
					inputAttributes: {
						class: "form-control dropdown-colonne",
					},
				},
			},
			levenshtein_limit: {
				title: "Écart maximal",
				default: "5",
				type: "integer",
			},
			brut: {
				title: "Tableau de résultat",
				default: false,
				type: "boolean",
				format: "checkbox",
			},
			columns_code_postaux: {
				type: "array",
				format: "table",
				title: "Mapping résultat",
				items: {
					type: "object",
					title: "Mapping",
					properties: {
						colonne: {
							title: "Colonne",
							type: "string",
							options: {
								inputAttributes: {
									class: "form-control dropdown-colonne",
								},
							},
						},
						mapping: {
							title: "Mapping",
							anyOf: [
								{
									type: "string",
									title: "Colonne de résultat",
								},
							],
						},
					},
				},
				default: [
					{ colonne: "Nom_commune", mapping: "insee_ville" },
					{ colonne: "Code_postal", mapping: "insee_code_postal" },
					{ colonne: "Ligne_5", mapping: "" },
					{ colonne: "Libellé_d_acheminement", mapping: "" },
					{ colonne: "coordonnees_gps", mapping: "" },
					{ colonne: "type", mapping: "type" },
				],
			},
		},
	};
}
